import type {
    Store,
    ListenerMiddlewareInstance,
    Middleware as ReduxMiddleware,
} from '@reduxjs/toolkit'
import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'

import { whenUnauthenticated } from '../API/toolbox'
import { isStagingEnv, isTestEnv } from '../config/constants'

import type { Middleware } from './common/actions'
import { bulkDispatchMiddleware } from './common/bulkDispatchMiddleware'
import { DetectedThatUserIsUnauthenticated } from './currentUser/actions'
import { rootReducer } from './store'
import { ClientViewportSizeChanged } from './viewMode/actions'

type StoreConnector = (store: Store) => void

export const makeStore = (
    middlewares: Middleware[],
    connectors: StoreConnector[],
    listenerMiddleware: ListenerMiddlewareInstance = createListenerMiddleware(),
) => {
    const store = configureStore({
        reducer: rootReducer(),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware()
                .prepend(listenerMiddleware.middleware as ReduxMiddleware)
                .concat([bulkDispatchMiddleware, ...middlewares] as ReduxMiddleware[]),
        devTools: isTestEnv || isStagingEnv ? { traceLimit: 15 } : false,
    })

    for (const connector of connectors) {
        connector(store)
    }

    window.addEventListener('resize', () =>
        store.dispatch(
            ClientViewportSizeChanged({
                width: document.body.clientWidth,
                height: window.innerHeight,
            }),
        ),
    )

    // handle user becoming logged out during session
    whenUnauthenticated(() => store.dispatch(DetectedThatUserIsUnauthenticated()))

    return store
}
